var symphony = symphony || {};

;
(function () {

    symphony.commConnIntegrationData = {};
    symphony.commConnIntegration = function (id, useAdminData, containerSelector) {
        useAdminData = useAdminData === true;

        $((containerSelector ? containerSelector + ' ' : '') + '.u-card[data-id="u-card-' + id + '"]').each(function (i, elm) {
            if (elm) {
                // don't worry about the spinner in admin
                // it gets annoying when typing in the alloy editor
                if (!useAdminData) {
                    elm.classList.add('local-loading');
                }
            }
        });

        var tmpCard = null;
        if (useAdminData && symphony && symphony.admin && symphony.admin.getActivePropertyName() == 'cards' && symphony.admin.getUpdatedData()) {
            var tmpCards = symphony.admin.getUpdatedData();
            tmpCard = $.grep(tmpCards.objects, function (c) {
                return c.id == id;
            })[0];
            if (window.localStorage.getItem('tmpCardData')) {
                tmpCard = JSON.parse(window.localStorage.getItem('tmpCardData'));
            }
        }

        if (!tmpCard && symphony.commConnIntegrationData[id]) {
            tmpCard = symphony.commConnIntegrationData[id];
        }
        if (tmpCard) {
            $((containerSelector ? containerSelector + ' ' : '') + '.u-card[data-id="u-card-' + id + '"]').each(function (i, elm) {
                renderCardDetails(elm, tmpCard, useAdminData);
            });
        } else {
            getTheCard(id, function (card) {
                $((containerSelector ? containerSelector + ' ' : '') + '.u-card[data-id="u-card-' + id + '"]').each(function (i, elm) {
                    renderCardDetails(elm, card, useAdminData);
                });
            });
        }


        function getTheCard(id, callback) {
            // get the properties
            var card = null;
            $.get('/' + siteUrlAlias + '/json/properties', function (data) {
                data = typeof data == "string" ? JSON.parse(data) : data;
                var cardProps = $.grep(data.objects, function (o) {
                    return o.name == "cards";
                });

                for (var i = 0; i < cardProps.length; i++) {
                    if (!card) {
                        cardProps[i].value = typeof cardProps[i].value == "string" ? JSON.parse(cardProps[i].value) : cardProps[i].value;
                        card = $.grep(cardProps[i].value.objects, function (c) {
                            return c.id == id;
                        })[0];
                    }
                }

                symphony.commConnIntegrationData[id] = card;

                if (typeof callback == "function") {
                    callback(card);
                }
            });
        }


        function renderCardDetails(elm, card, useAdminData) {
            if (card) {
                var rightNow = new moment();
                if (card.commConnData && card.commConnData.endDate && rightNow.isAfter(card.commConnData.endDate)) {
                    $(elm).remove();
                    return;
                }
                if (useAdminData && card.commConnData && card.commConnData.cachedDetails) {
                    renderIt(card);
                } else if (card.commConnData && card.commConnData.detailsApiUrl.length > 0) {
                    // don't worry about the spinner in admin
                    // it gets annoying when typing in the alloy editor
                    if (!useAdminData) {
                        elm.classList.add('local-loading');
                    }
                    $.ajax({
                        type: 'GET',
                        url: card.commConnData.detailsApiUrl,
                        contentType: 'application/json',
                        success: function (resp) {
                            elm.classList.remove('local-loading')
                            card.commConnData.cachedDetails = resp.data;
                            if (useAdminData) {
                                // this will set the cachedDetails in admin mode
                                window.localStorage.setItem('tmpCardData', JSON.stringify(card));
                            }
                            renderIt(card);
                        },
                        error: function () {
                            if (card.commConnData.cachedDetails) {
                                renderIt(card);
                            } else {
                                elm.classList.remove('local-loading')
                                if (elm.querySelector('.u-card-commConnIntegration')) {
                                    elm.querySelector('.u-card-commConnIntegration').innerHTML = '<div class="u-textCenter">An error has occurred. <br />Please try again soon.</div>';
                                }
                            }
                        }
                    });
                } else {
                    renderIt(card);
                }
            } else {
                if (elm.querySelector('.u-card-commConnIntegration')) {
                    elm.querySelector('.u-card-commConnIntegration').innerHTML = '<div class="u-textCenter">An error has occurred. <br />Please try again soon.</div>';
                }
            }

            function renderIt(card) {
                parsedData = symphony.parseCommConnData(card);
                if (elm.querySelector('.u-card-commConnIntegration')) {
                    elm.querySelector('.u-card-commConnIntegration').innerHTML = symphony.templates['card-commConnIntegration']({
                        commConnData: card.commConnData,
                        priceText: parsedData.priceText,
                        priceSubtext: parsedData.priceSubtext,
                        text: card.text,
                        includeMarketingDescription: card.includeMarketingDescription
                    });
                }
            }
        }
    };

    symphony.parseCommConnData = function (card) {
        var retVal = {
            priceText: '',
            priceSubtext: ''
        };

        if (card.commConnData && card.commConnData.resultType) {
            switch (card.commConnData.resultType) {
                case 1: // class
                    if (card.commConnData.cachedDetails.autoPayCost) {
                        retVal.priceText = card.commConnData.cachedDetails.autoPayCost;
                        retVal.priceSubtext = 'PER MONTH';
                    } else if (card.commConnData.cachedDetails.singleVisitPrice) {
                        retVal.priceText = card.commConnData.cachedDetails.singleVisitPrice;
                        retVal.priceSubtext = 'PER VISIT';
                    } else if (card.commConnData.cachedDetails.classPrice) {
                        retVal.priceText = card.commConnData.cachedDetails.classPrice;
                        retVal.priceSubtext = '';
                    }
                    break;
                case 2: // daypass
                    if (card.commConnData.cachedDetails.autoPayCost) {
                        retVal.priceText = card.commConnData.cachedDetails.autoPayCost;
                        retVal.priceSubtext = 'PER MONTH';
                    } else if (card.commConnData.cachedDetails.dailyCost) {
                        retVal.priceText = card.commConnData.cachedDetails.dailyCost;
                        retVal.priceSubtext = 'PER DAY';
                    } else if (card.commConnData.cachedDetails.monthlyCost) {
                        retVal.priceText = card.commConnData.cachedDetails.monthlyCost;
                        retVal.priceSubtext = 'PER MONTH';
                    }
                    break;
                case 3: // membership
                    if (card.commConnData.cachedDetails.autoPayCost) {
                        retVal.priceText = card.commConnData.cachedDetails.autoPayCost;
                        retVal.priceSubtext = 'PER MONTH';
                    } else if (card.commConnData.cachedDetails.monthlyCost) {
                        retVal.priceText = card.commConnData.cachedDetails.monthlyCost;
                        retVal.priceSubtext = 'PER MONTH';
                    } else if (card.commConnData.cachedDetails.dailyCost) {
                        retVal.priceText = card.commConnData.cachedDetails.dailyCost;
                        retVal.priceSubtext = 'PER DAY';
                    }
                    break;
            }
        }

        return retVal;
    };
})();
